import React,{useState, useEffect, Component} from 'react'; 
import styled from "styled-components"
import LineDivider from '../LineDivider'

const UpArrow = require('../../../../assets/imgs/upArrow.png');
const DownArrow = require('../../../../assets/imgs/downArrow.png');


// {
//     "billeraccountid": "HGA1A125AE0026253343",
//     "billerType": "BILLER",
//     "billerName": "Urban Improvement Trust (UIT) - Bhiwadi",
//     "authenticator": "037121251",
//     "setAutoPay": "true"
// },
// {
//     "billAmount": "10.00",
//     "billeraccountid": "HGA1A0C5B70037226381",
//     "billerType": "PAYEE",
//     "billerName": "Airtel Prepaid",
//     "authenticator": "9654241952",
//     "cardno": "xxxx xxxx xxxx 7967",
//     "frequency": "Annually",
//     "setAutoPay": "false"
//   }
// let something = 

//     [ 
//         {
//             "billId": "HGA1A17EA40030214452",//billId
//             "billerType": "BILLER",//billerType
//             "billerName": "Idea Prepaid",//billerName ---
//             "authenticator": "6356021993",//authenticator ---
//             "billDueDate": "03-10-2020",//billDueDate ---
//             "billAmount": "19.00",//billAmount ---
//             "billStatus": "UNPAID",//billStatus ---
//             "payNow": "true"//payNow
//           }, 

//         {
//             "billId": "HGA1A17EA40030214452",
//             "billerType": "BILLER",
//             "billerName": "Idea Prepaid",
//             "authenticator": "6356021993",
//             "billDueDate": "03-10-2020",
//             "billAmount": "19.00",
//             "billStatus": "UNPAID",
//             "payNow": "true"
//           }, 
//         {
//         "billId": "HGA1A17EA40030214452",
//         "billerType": "PAYEE",
//         "billerName": "Idea Prepaid",//
//         "authenticator": "6356021993",//
//         "billDueDate": "03-10-2020",//
//         "billAmount": "19.00",//
//         "billStatus": "SCHEDULED",//
//         "payNow": "false"
//       }
     
  
//       ]
    
const GetUpcommingBills = (props) => {

  const {getUpcommingBills} = props; 
   //const getUpcommingBills = something;//For testing -> remove this
 // console.log(getUpcommingBills);

    const handleCancelButton = () => {

      let inputString = 'Cancel' + "<split>" + 'Cancel';
      window['autosubmit'](inputString);

     //here
      document.querySelectorAll('.disableBiller').forEach(item=>{
       // console.log(item)
          item.classList.add('disabled');
      })

    }

//CSS
    const ButtonCancel=styled.div`  
        width:92%;
        margin:10px auto;
        margin-top: 15px;
        background: #2c387a;
        color: white;
    `
//

  const showSelectedEMIDetail = ()=>{
    return( <div style={{width:"280px"}} className="disableBiller">

    {getUpcommingBills.map((item,i)=>{
        return(
           
            <RegisteredBillersWrapper key={i}>

                 <RegisteredBillerAccordion id="disableAccordion"
                              
                
                         BillerName={item.billerName}
                         Authenticator={item.authenticator}
                         BillID={item.billId}
                         BillerType={item.billerType}
                         PayNow={item.payNow}
                         Authenticator={item.authenticator}
                         DueDate={item.billDueDate}
                         Status={item.billStatus}
                         Amount={item.billAmount}
                           
                />
            </RegisteredBillersWrapper>
            )
        })
    }</div>
    );
    }
    return (
        <React.Fragment>
            {showSelectedEMIDetail()}

            {/* {getUpcommingBills[0].payNow == "false"?null: */}
             <ButtonCancel className="action-elem" onClick={()=> handleCancelButton()}>Cancel</ButtonCancel>
            
            {/* } */}
               
        </React.Fragment>
    );
};

    const RegisteredBillersWrapper = styled.div`
        display:flex;
        flex-direction : column;
        margin: 15px 0;
        width: 100%;
       
`
//RegisteredBillerAccordion Component

class RegisteredBillerAccordion extends Component{

    constructor(props) {
        super(props);
        this.state = {
         backgroundImage: DownArrow,
         isClicked:false,
         showSummaryDetail:false,
         borderState:'none'
        };
  }

    handleClickState =()=>{
        if(this.state.isClicked == false){
                this.setState({
                    isClicked:true,
                    backgroundImage:UpArrow,
                    showSummaryDetail: true
                })
        }else{
            this.setState({
                isClicked:false,
                backgroundImage:DownArrow,
                showSummaryDetail: false
            })
        }
    }

    handleAutoPayButton =(BillID) => {
        // alert("clicked");
       // console.log(BillID)
        let inputString = 'Pay Now' + "<split>" + BillID;
        window['autosubmit'](inputString);

        document.querySelectorAll('.disableBiller').forEach(item=>{

          //  console.log(item)
              item.classList.add('disabled');
          })

        this.setState({
            borderState:'2.5px solid #5b669b'
        })
      
    }
   
render(){

    const Summary_mainBlock=styled.div`
        position: relative;
        display:flex;
        flex-direction : column;
        margin: 0px 12px;
        border: 1px solid #fcfcfc;;
        border-radius: 4px;
        box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
        background: #fcfcfc;
    `
    const Summary_titleBlock=styled.div` 

     cursor: pointer;

        & .billerTitle{
            font-size:14px;
            font-weight: 550;
            padding: 12px;
            padding-bottom: 6px;
            width:220px;
        
        }

        & .billerSubtitle{
            font-size:12px;
            padding: 12px;
            padding-top: 0px;
            padding-left: 14px
            width:220px;

        }

        & .arrowBlock{
            position:absolute;
            top: 16px;
            right:0px;
            height:30px;
            width:30px;
            background: url(${this.state.backgroundImage});
            background-repeat: no-repeat;
        }
    `
    const Summary_detailBlock=styled.div`
        font-size:12px;
  
    `
    const DashDivider=styled.div`
        border-bottom:1px dashed rgba(102,102,102,0.2);
    `
    const PlanRow =styled.div`
        padding:10px 12px;
   
    `
    const PlanLabel = styled.div`
        display: inline-block;
        vertical-align:middle;
        width:40%;
        text-align: left;
        margin:0px;
    `
    const PlanValue = styled.div`
        display: inline-block; 
        vertical-align:middle; 
        width:60%;
        text-align: right;
        font-weight:600;
       
    `
    const PayNowButton = styled.div `
        // height: 40px;
        // width: auto;  
    `
//
    return(
        <Summary_mainBlock id="summaryWrapper" style={{border:`${this.state.borderState}`}}>         
            <Summary_titleBlock onClick={() => this.handleClickState()}>
                    <div className="billerTitle">
                            {this.props.BillerName}  
                    </div>
                    <div className="billerSubtitle">
                            {this.props.Authenticator}  
                    </div>
                    <div className="arrowBlock"></div>
            </Summary_titleBlock>

            {this.state.showSummaryDetail?
            <Summary_detailBlock>
                <DashDivider/>
                    <div>
                    {this.props.DueDate != undefined?
                    <div>
                         <DashDivider/>
                        <PlanRow>
                            <PlanLabel>Due Date</PlanLabel>
                            <PlanValue>{this.props.DueDate}</PlanValue>
                        </PlanRow>
                    </div>:null}
                    {this.props.Status != undefined?
                    <div>
                         <DashDivider/>
                        <PlanRow>
                            <PlanLabel>Status</PlanLabel>
                            <PlanValue>{this.props.Status}</PlanValue>
                        </PlanRow>
                    </div>:null}
                    {this.props.Amount != undefined?
                    <div>
                         <DashDivider/>
                        <PlanRow>
                            <PlanLabel>Amount</PlanLabel>
                            <PlanValue>{this.props.Amount}</PlanValue>
                        </PlanRow>
                    </div>:null}
                    <div>
                    <DashDivider/>
                    {this.props.PayNow=="true"? 
                    <PlanRow>
                        <PayNowButton id={this.props.BillID} className="action-elem" onClick={()=> this.handleAutoPayButton(this.props.BillID)}>
                            Pay Now
                        </PayNowButton>
                    </PlanRow>:null}
                    </div> 
                   
                    </div>
                    {/* } */}
                
              
            </Summary_detailBlock>
            :null}       
        
        </Summary_mainBlock>     
    );
  }
};
 

export default GetUpcommingBills;

